/* eslint-disable no-redeclare */
import React, { useCallback } from 'react';

import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useParams } from 'react-router-dom';

import SendEmailsDialog from 'components/dialogs/sendMessageDialog/SendEmailsDialog';
import type { MatchUpInterface } from 'typedefs/store/scheduleTypes';
import type { ParticipantInterface } from 'typedefs/store/tmxTypes';
import { participantsMapper } from 'utils/participant';

interface ModalProps {
  matchUp: MatchUpInterface;
  participants: ParticipantInterface[];
}
const Modal = NiceModal.create(({ matchUp, participants }: ModalProps) => {
  const modal = useModal();
  const { tournamentId } = useParams<{ tournamentId: string }>();

  return (
    <SendEmailsDialog
      isOpen={modal.visible}
      {...(matchUp && { matchUp })}
      participants={participants}
      tournamentId={tournamentId}
      onClose={modal.hide}
      onExited={modal.remove}
    />
  );
});

function showEmailDialog(data: MatchUpInterface | ParticipantInterface[]) {
  const matchUp = !Array.isArray(data) ? data : undefined;
  const participants = matchUp ? participantsMapper(matchUp?.sides ?? []) : (data as ParticipantInterface[]);
  if (participants.length) NiceModal.show(Modal, { matchUp, participants });
}

export const useEmailDialog = () => useCallback(showEmailDialog, []);
